import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Field, TextInput, PrimaryButton } from "@/components/FormKit";
import StatusBadge from "@/components/StatusBadge";
import { toast } from "sonner";
import { fmtCurrency, fmtDate } from "@/lib/format";

export default function Profile() {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ name: "", phone: "", address: "", website: "", logo_url: "" });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data: d } = await api.get("/company/profile");
    setData(d);
    setForm({
      name: d.company?.name || "",
      phone: d.company?.phone || "",
      address: d.company?.address || "",
      website: d.company?.website || "",
      logo_url: d.company?.logo_url || "",
    });
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch("/company/profile", form);
      toast.success("Profile saved");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  if (!data) return <div className="overline text-stone-500">Loading…</div>;

  return (
    <div className="space-y-8" data-testid="company-profile-page">
      <PageHeader eyebrow="Account" title="Company profile" description="Your brand details and active subscription." />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <form onSubmit={save} className="lg:col-span-2 grid-surface p-6">
          <Field label="Company name"><TextInput testId="form-profile-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Phone"><TextInput testId="form-profile-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Field>
            <Field label="Website"><TextInput testId="form-profile-web" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} /></Field>
          </div>
          <Field label="Address"><TextInput testId="form-profile-address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Field>
          <Field label="Logo URL"><TextInput testId="form-profile-logo" value={form.logo_url} onChange={(e) => setForm({ ...form, logo_url: e.target.value })} /></Field>
          <div className="pt-2">
            <PrimaryButton type="submit" disabled={busy} testId="save-profile-button">{busy ? "Saving…" : "Save"}</PrimaryButton>
          </div>
        </form>

        <aside className="grid-surface p-6 h-fit">
          <div className="overline text-stone-500">Subscription</div>
          {data.subscription && data.plan ? (
            <>
              <div className="font-display text-2xl font-black mt-2">{data.plan.name}</div>
              <div className="font-mono text-sm text-stone-600">{fmtCurrency(data.plan.price)}/{data.plan.billing_cycle}</div>
              <div className="mt-3"><StatusBadge value={data.subscription.status} /></div>
              <div className="mt-4 grid grid-cols-2 gap-2 text-xs font-mono border-t border-stone-200 pt-3">
                <div><div className="text-stone-400">PROJECTS</div><div className="text-stone-950 font-bold">{data.plan.max_projects}</div></div>
                <div><div className="text-stone-400">CUSTOMERS</div><div className="text-stone-950 font-bold">{data.plan.max_customers}</div></div>
                <div><div className="text-stone-400">USERS</div><div className="text-stone-950 font-bold">{data.plan.max_portal_users}</div></div>
                <div><div className="text-stone-400">SITES</div><div className="text-stone-950 font-bold">{data.plan.max_sites}</div></div>
              </div>
              <div className="mt-4 text-xs text-stone-500 font-mono">
                Expires {fmtDate(data.subscription.end_date)}
              </div>
            </>
          ) : (
            <div className="text-stone-400 text-sm mt-3">No active subscription.</div>
          )}
        </aside>
      </div>
    </div>
  );
}
